import {observable} from 'mobx';

export default class UnitStore{
  @observable items = [];
  transportLayer;

  constructor(transportLayer){
    this.transportLayer = transportLayer
  }

  fetch(){
    this.transportLayer.fetch().then(res => {
      this.items = res;
    }).catch(console.log);
  }

  findById(id){
    return this.items.filter(item => +item.id === +id)[0];
  }
}


// WEBPACK FOOTER //
// ./src/store/UnitStore.js